<footer class="app-footer">
  <!-- <span><a href="http://maker.co.nz">Maker</a> &copy; 2017 Maker Design Ltd.</span> -->
  <span class=""><b>©</b> {{year}} Maker Design, Ltd. </span>
  <span class="ml-auto logo">
    <img style="margin-bottom: 0px;" src="/assets/img/logo-black-crop.png" alt="" height="37">
  </span>
  <span class="ml-auto">Search Admin</span>&nbsp;
  <span class="badge badge-light"><b>Build V.{{version}}</b></span>
</footer>
